export default {"src":"/_next/static/media/brush_24.f9a038b8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};